import GetUsersRequestModelBase from '../_generated/modelBases/get-users-request-model-base';

export default class GetUsersRequestModel extends GetUsersRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
